// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

// Init Lenis
const lenis = new Lenis({
	duration: 2,
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
})

//Preload
const preload = document.querySelector('#preload')
const startContent = document.querySelector('#start-content')

if (!sessionStorage.getItem('preloaded') && preload && startContent) {
	lenis.stop()
	preload.classList.add('loading')
	setTimeout(function () {
		preload.classList.add('fade-out')
		setTimeout(function () {
			preload.classList.remove('loading', 'fade-out')
			startContent.classList.add('loaded')
			lenis.start()
			sessionStorage.setItem('preloaded', true)
			initGSAPAnimations()
		}, 5)
	}, 5000)
} else {
	startContent.classList.add('loaded')
	initGSAPAnimations();
}

function raf(time) {
	lenis.raf(time)
	requestAnimationFrame(raf)
}

requestAnimationFrame(raf)
;(function () {
	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}
	//Menu scroll Functionality
	if (location.pathname === '/inngenuity' || location.pathname === '/') {
		const links_scroll = document.querySelectorAll(
			'#privary-navigation a:not(.logo), .burger-menu__nav a:not(.logo)',
		)
		links_scroll.forEach((link) => {
			link.addEventListener('click', (e) => {
				e.preventDefault()
				const targetID = e.currentTarget.getAttribute('href').substring(1)
				const targetElement = document.querySelector(targetID)
				if (targetElement && window.innerWidth >= 768) {
					const offset = -60
					lenis.scrollTo(targetElement, {
						offset,
						duration: 3,
						easing: (t) => 1 - Math.pow(1 - t, 5),
						//immediate: true
					})
				}
				if (targetElement && window.innerWidth <= 768) {
					animateTo(targetElement);
					lenis.start();
					document.body.classList.toggle('no-scroll')
				}
				const menuBurger = document.querySelector('[data-menuburger]')
				if (menuBurger) {
					menuBurger.classList.remove('open')
				}
			})
		})
	}

	lenis.on('scroll', () => ScrollTrigger.update())

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//Burger Menu
	const burger_CTAS = document.querySelectorAll('[data-ctaburger]')
	const burger_Content = document.querySelector('[data-menuburger]')

	burger_CTAS.forEach((currentItem) => {
		currentItem.addEventListener('click', (e) => {
			e.preventDefault()
			burger_Content.classList.toggle('open')
			document.body.classList.toggle('no-scroll')
			burger_Content.classList.contains('open') ? lenis.stop() : lenis.start()
		})
	})
	
	//animation scroll
	const ctas_scroll = document.querySelectorAll('[data-scroll],.scroll');
	if (ctas_scroll) {
		ctas_scroll.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				const section_to_scroll = new URL(e.target.href)
				animateTo(document.querySelector(section_to_scroll.hash))
			})
		})
	}

	//Simple accordion functionality
	initAccordion('[data-simpleaccordion]', true)
	initAccordion('[data-asideaccordion]', false)

	//Table checkbox functionality
	const tableCheckboxes = document.querySelectorAll('.table-services table td')
	tableCheckboxes.forEach((check) => {
		if (check.textContent === '#') {
			const svgCheck = `<svg id="check" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
													<circle id="Ellipse_3" data-name="Ellipse 3" cx="9" cy="9" r="9" fill="#53c071"/>
													<path id="Path_60" data-name="Path 60" d="M.361,4.627l3.413,2.91L9.265.262" transform="translate(4.139 5.237)" fill="none" stroke="#010101" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.2"/>
												</svg>`
			check.innerHTML = svgCheck
		}
	})
})()

//Scroll function
function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}

// accordion function
function initAccordion(selector ,scroll) {
  const accordionTitles = document.querySelectorAll(selector);
  accordionTitles.forEach((title) => {
    title.addEventListener("click", () => {
      const wrap = title.nextElementSibling;

      accordionTitles.forEach((otherTitle) => {
        if (otherTitle !== title) {
          const otherWrap = otherTitle.nextElementSibling;
          gsap.to(otherWrap, {
            height: 0,
            opacity: 0,
            duration: 0.7,
            ease: "power2.inOut",
            onComplete: () => {
              otherWrap.classList.remove("active");
              otherTitle.classList.remove("active");
            }
          });
        }
      });

      if (wrap.classList.contains("active")) {
        gsap.to(wrap, {
          height: 0,
          opacity: 0,
          duration: 0.7,
          ease: "power2.inOut",
          onComplete: () => {
            wrap.classList.remove("active");
            title.classList.remove("active");
            ScrollTrigger.refresh();
          }
        });
      } else {
        const contentHeight = wrap.scrollHeight;
        wrap.style.height = "0";
        wrap.classList.add("active");
        title.classList.add("active");

        gsap.to(wrap, {
          height: contentHeight,
          opacity: 1,
          duration: 0.7,
          ease: "power2.inOut",
          onStart: () => {
            wrap.style.transition = "none";
          },
          onComplete: () => {
            wrap.style.height = "auto";
            wrap.style.transition = "";
            ScrollTrigger.refresh();
						if(scroll == true) {
							smoothScrollTo(title, -50); 
						}
          }
        });
      }
    });
  });
}


function smoothScrollTo(element, offset = 0) {
  const targetPosition = element.getBoundingClientRect().top + window.scrollY + offset;
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  const duration = 500; 
  let startTime = null;

  function animation(currentTime) {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    
    const easeInOutQuad = progress < 0.5 
      ? 2 * progress * progress 
      : 1 - Math.pow(-2 * progress + 2, 2) / 2;

    window.scrollTo(0, startPosition + distance * easeInOutQuad);

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
}


function animateTo(target) {
	var gotoTarget =
		location.pathname == '/'
			? offset(target).top - 40
			: offset(target).top - 110
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1000
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
}
